module.exports = __webpack_public_path__ + "img/cover-slot-bg.daf134d3.jpg";